import api from './api';
import { Rig, CreateRigData, UpdateRigData } from '../types/rig';

export interface RigListResponse {
  success: boolean;
  data: Rig[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    pages: number;
  };
}

export interface RigResponse {
  success: boolean;
  data: Rig;
  message?: string;
}

export const rigService = {
  async getRigs(params?: {
    page?: number;
    limit?: number;
    search?: string;
    sortBy?: string;
    sortOrder?: 'asc' | 'desc';
  }): Promise<RigListResponse> {
    const response = await api.get('/rigs', { params });
    return response.data;
  },

  async getRigById(id: number): Promise<RigResponse> {
    const response = await api.get(`/rigs/${id}`);
    return response.data;
  },

  async createRig(data: CreateRigData): Promise<RigResponse> {
    const response = await api.post('/rigs', data);
    return response.data;
  },

  async updateRig(id: number, data: UpdateRigData): Promise<RigResponse> {
    const response = await api.put(`/rigs/${id}`, data);
    return response.data;
  },

  async deleteRig(id: number): Promise<{ success: boolean; message: string }> {
    const response = await api.delete(`/rigs/${id}`);
    return response.data;
  }
};
